import { IProductFormValues } from "../index";
import { MAX_LOCATIONS } from "../../../../constants/Constants";
import { validateArea } from "../../../../validation/Validators";
import { Area } from "../../../../entities/Area";
import { compact } from "lodash";
import { Nullable } from "../../../../../types/utils";

const ensureNonEmptyArray = (
  value: Nullable<Array<any>>,
  message: string = 'At least one value is required.'
): string | undefined => {
  return !value || value.length <= 0 ? message : undefined;
}

const validateLocation = (value: IProductFormValues['location']) => {
  if (!value) {
    return 'Required.'
  }

  if (value < 1 && value > MAX_LOCATIONS) {
    return `Required a number between 1 and ${MAX_LOCATIONS}`
  }

  return;
}

const validateAreas = (areas: Array<Area>): string | undefined => {
  const errors = [];
  const isEmptyError = ensureNonEmptyArray(areas);

  if (isEmptyError) {
    errors.push(isEmptyError);
  }

  errors.push(
    ...compact(areas.map(area => validateArea(area).error))
  );

  return errors[0];
}

type TArrayProperties = 'steps'
  | 'areas'
  | 'grid'
  | 'use'
  | 'hindcast'
  | 'fcmonth'
  | 'param'
  | 'param_levelist'
  | 'param_quantile'
  | 'time'
  | 'time_step'
  | 'use_step'
  | 'direction'
  | 'frequency';

const validateProductArrayProperty = <T extends TArrayProperties>(
  value: IProductFormValues[T]
) => ensureNonEmptyArray(value)

// const validateHindcast = (value: Nullable<Array<string>>) => {
//   if (value.length === 0) {
//     return 'Value is required.'
//   }
//
//   return;
// }

export {
  // validateHindcast,
  validateLocation,
  validateAreas,
  validateProductArrayProperty
}
